import React from 'react';
import { EpiLink, MaterialIcon } from '@api/types';
import { HeaderIconButton, SmartLink } from '@components';
import { styled } from '@mui/material';

export type HeaderLinkBlockProps = {
  children?: React.ReactNode;
  link?: EpiLink;
  icon?: MaterialIcon;
};

const Wrapper = styled('div')<HeaderLinkBlockProps>``;

export const HeaderLinkBlock = ({ link, icon }: HeaderLinkBlockProps) => {
  const clickHandler = () => null;
  return (
    <Wrapper className='link-block'>
      <SmartLink {...link}>
        <HeaderIconButton iconName={icon} onClick={clickHandler} sx={{ ml: 'auto' }} />
      </SmartLink>
    </Wrapper>
  );
};
